import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ProxyService } from '@core/services';
import { EmergencyBanner } from '@features/home/models';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
import { Subscription } from 'rxjs';
import { LoggingService } from '@core/services/logging.service';



@Component({
  selector: 'app-emergency-banner',
  templateUrl: './emergency-banner.component.html',
  styleUrls: ['./emergency-banner.component.less']
})
export class EmergencyBannerComponent implements OnInit, OnDestroy {
  @Input() isEmergencyBanner: boolean;
  @Output() onCloseEmergency: EventEmitter<any> = new EventEmitter();
  private subscriptions = new Subscription();
  public emergencyText: string;
  public buttonText: string;
  public goToUrl: string;
  public showEmergencyBanner: boolean;
  constructor(private proxy: ProxyService,
    private logger: LoggingService
  ) {
    this.isEmergencyBanner = false;

  }

  ngOnInit() {
    this.checkIfEmergency();
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  checkIfEmergency() {
    this.subscriptions.add(
      this.proxy.httpGet(ApiRoutes.EMERGENCY_BANNER).subscribe(
        (success) => {
          if (success.body) {
            const response = <EmergencyBanner>success.body.valueOf();
            if (response) {
              this.emergencyText = response.content ? response.content : null;
              this.buttonText = response.buttonText ? response.buttonText : null;
              this.goToUrl = response.action ? response.action : null;
              this.showEmergencyBanner = true;
            }
          } else {
            this.close();
          }
        },
        (error) => {
          this.logger.logError(error);
        }
      )
    );
  }
  navigateTo() {
    window.open(this.goToUrl, '_blank');
  }

  close() {
    this.showEmergencyBanner = false;
    this.onCloseEmergency.emit();
  }
}
